var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-bookmark"},[_c('el-tabs',{staticClass:"base-tabs",attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"书签列表"}},[_c('list-com')],1),_c('el-tab-pane',{attrs:{"label":"书签动画"}},[_c('animation-com')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }